import {motion} from 'framer-motion';
import Card from '../../shared/Card';
import GeneralContext from '../../../context/GeneralContext';
import ButtonFunction from '../../shared/ButtonFunction';
import { useContext, useState } from 'react';
import { fetchBody } from '../../../utils/fetch';
import TextInputHorizontalTag from "../../shared/TextInputHorizontalTag";

function RestoreUserPassword() {

    const {
        changeCurrentMenu,
        changeModalTitle,
        changeModalText,
        changeModalType,
        userResetData
    } = useContext(GeneralContext);

    const [password, setPassword] = useState("");
    const changePassword = (e) => {
        setPassword(e.target.value);
    }

    const [passwordConfirm, setPasswordConfirm] = useState("");
    const changePasswordConfirm = (e) => {
        setPasswordConfirm(e.target.value);
    }

    const newPasswordFunction = async () => {
        const modal = document.getElementById("myModal");
        if (password === '' || passwordConfirm === '') {
            changeModalTitle('Error');
            changeModalText('Los campos no pueden estar vacíos');
            changeModalType('alert');
            modal.style.display = "block";
        } else {
            if (password !== passwordConfirm) {
                changeModalTitle('Error');
                changeModalText('Las contraseñas no coinciden');
                changeModalType('alert');
                modal.style.display = "block";
                return false;
            }
            const data = {id: userResetData.id, password: password};
            const response = await fetchBody('change_forgotten_password_admin', 'PUT', data);
            if (response.success) {
                changeModalTitle('Éxito!');
                changeModalText('La contraseña se ha restablecido exitosamente');
                changeModalType('alert');
                modal.style.display = "block";
                changeCurrentMenu('active-users');
            } else {
                changeModalTitle('Error al intentar la operación');
                changeModalText(response.reason);
                changeModalType('alert');
                modal.style.display = "block";
            }
        }
    }

  return (
    <motion.div
      id='adminResetUserPasswordCard'
      key='adminResetUserPassword'
      initial={{opacity: 0, x: -1000}}
      animate={{opacity: 1, x: 0}}
      exit={{opacity: 0, x: -1000}}
      transition={{duration: 0.5}}>
        <Card hasBackNavigation={true} backNavigationFunction={changeCurrentMenu} backNavigationTarget={'restore-user'}>
            <h2>Nueva contraseña para {userResetData.name}</h2>
            <TextInputHorizontalTag label='Contraseña' type='password' inputClass='adminInput' changeEvent={changePassword}/>
            <TextInputHorizontalTag label='Confirmar contraseña' type='password' inputClass='adminInput' changeEvent={changePasswordConfirm}/>
            <br />
            <ButtonFunction buttonClass='adminButton' buttonFunction={newPasswordFunction}>Restablecer</ButtonFunction>
        </Card>
    </motion.div>
  )
}

export default RestoreUserPassword